import { KeyOf } from '~/types';

export const zIndex = {
  header: 10,
  navigation: 10,
  modal: 100,
  background: 99,
  midModal: 5,
} as const;

export type ZIndex = typeof zIndex;
export type ZIndexKeys = KeyOf<typeof zIndex>;
